import {cardPaymentHistorySlice} from './../../../reducers/transportCard/cardPaymentsHistory/index';
import {TransportCardPaymentHistoryItem} from '../../../../shared/models/api/transportCardPaymentHistory';
import {AppThunk} from '../../index';
import {stateProgramSlice} from '../../../reducers/socialSupport/statePrograms';
import {httpService, HttpWrapperOptions} from '../../../../shared/httpWrapper';
import {getApiRoute} from '../../../../shared/pipes';
import {apiUrls} from '../../../../shared/constants/urls';
import {getTransportCardNumber} from '../../../../shared/utils/card';

export const setStatePrograms = stateProgramSlice.actions.setStatePrograms;

export const getTransportCardPaymentHistory = (cardNumber: number): AppThunk => {
  return async (dispatch) => {
    const options = new HttpWrapperOptions();
    options.apiServer = 'transportCard';

    try {
      const response = await httpService.get<TransportCardPaymentHistoryItem[]>(
        getApiRoute(
          apiUrls.getTransportCardPaymentHistory,
          {cardNumber: getTransportCardNumber(cardNumber)},
          undefined,
          options.apiServer,
        ),
        options,
      );

      dispatch(cardPaymentHistorySlice.actions.setData(response));
    } catch {}

    dispatch(cardPaymentHistorySlice.actions.setLoaded(true));
  };
};
